import { useQuery } from "@tanstack/react-query";

import { fetchDocsList, fetchDoc } from "@/lib/api";

export function useDocsList() {
  return useQuery({
    queryKey: ["docs-list"],
    queryFn: fetchDocsList,
    staleTime: 5 * 60 * 1000, // docs don't change often
  });
}

export function useDoc(slug: string | null) {
  return useQuery({
    queryKey: ["doc", slug],
    queryFn: () => fetchDoc(slug!),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });
}
